import { render } from "./fiscalData.vue?vue&type=template&id=f5b62d52&ts=true"
import script from "./fiscalData.vue?vue&type=script&lang=ts"
export * from "./fiscalData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__